import { render, staticRenderFns } from "./assetAllocation.vue?vue&type=template&id=9261b7a8&scoped=true"
import script from "./assetAllocation.vue?vue&type=script&lang=js"
export * from "./assetAllocation.vue?vue&type=script&lang=js"
import style0 from "./assetAllocation.vue?vue&type=style&index=0&id=9261b7a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9261b7a8",
  null
  
)

export default component.exports